/* global algolia, instantsearch, algoliaExtra, algoliasearch, current_locale */
export default {
  init() {
    /*
    (VERKSAMHETER ARE NOT ON LARA, BUT THIS COMMENT IS HERE AS A REFERENCE)
    The main search (the all) is not possible to add the verksamheter mixed in within the list.
    Or at least is not possible with the version of instantsearch.js that we're using.
    https://www.algolia.com/doc/guides/building-search-ui/ui-and-ux-patterns/multi-index-search/js/?client=react

    The solution implemented here is a hack, not reliable.
    */

    if ($('#algolia-search-box').length <= 0) {
      return;
    }

    if (typeof algolia === 'undefined') {
      return;
    }

    var labels = algoliaExtra.text;

    jQuery('.ss_load_morebtn').text(labels.viewMore);
   
    if (algolia.indices.searchable_posts === undefined && $('.admin-bar').length > 0) {
      alert('It looks like you haven\'t indexed the searchable posts index. Please head to the Indexing page of the Algolia Search plugin and index it.');
    }

    //STAT NAV LOGIC
    $('.nav-tabbed-search a[data-toggle="tab"]').on('show.bs.tab', function (e) {
      var relatedStat = $(e.target).attr('data-stat');
      console.log(relatedStat);
      $('#stats-nav .tab-pane').removeClass('show').removeClass('active');
      $(relatedStat).addClass('show').addClass('active');
    });

    //SEARCH INIT
    var main = instantsearch({
      indexName: algolia.indices.searchable_posts.name,
      searchClient: algoliasearch( algolia.application_id, algolia.search_api_key ),
      routing: {
        router: instantsearch.routers.history({ writeDelay: 1000 }),
        stateMapping: {
          stateToRoute: function stateToRoute( indexUiState ) {
            return {
              s: indexUiState[ algolia.indices.searchable_posts.name ].query,
              page: indexUiState[ algolia.indices.searchable_posts.name ].page,
            };
          },
          routeToState: function routeToState( routeState ) {
            var indexUiState = {};
            indexUiState[ algolia.indices.searchable_posts.name ] = {
              query: routeState.s,
              page: routeState.page,
            };
            return indexUiState;
          },
        },
      },
      searchFunction: function(helper) {
         var query = helper.state.query;

         postsSearch.helper.setQuery(query);
         postsSearch.helper.setQueryParameter( 'filters', 'wpml.locale:"' + current_locale + '"');
         postsSearch.helper.search();
         pagesSearch.helper.setQuery(query);
         pagesSearch.helper.setQueryParameter( 'filters', 'wpml.locale:"' + current_locale + '"');
         pagesSearch.helper.search();
         helper.setQueryParameter( 'filters', 'wpml.locale:"' + current_locale + '"');
         helper.search();
      },
    });
    
    var postsSearch = instantsearch({
      searchClient: algoliasearch( algolia.application_id, algolia.search_api_key ),
      indexName: algolia.indices.posts_post.name,
    });

    var pagesSearch = instantsearch({
      searchClient: algoliasearch( algolia.application_id, algolia.search_api_key ),
      indexName: algolia.indices.posts_page.name,
    });

    //TABS
    var searchHits = instantsearch.widgets.infiniteHits({
      container: document.querySelector('#algolia-hits-all'),
      templates: {
        empty:labels.noResults,
        item: wp.template('instantsearch-hit'), //instantsearch-hit-2
        showMoreText: labels.viewMore,
      },
    });
    
    var postsSearchHits = instantsearch.widgets.infiniteHits({
      container: document.querySelector('#algolia-hits-posts'),
      templates: {
        empty: labels.noResults,
        item: wp.template('instantsearch-hit'), //instantsearch-hit-2
        showMoreText: labels.viewMore,
      },
    });

    var pagesSearchHits = instantsearch.widgets.infiniteHits({
      container: document.querySelector('#algolia-hits-pages'),
      templates: {
        empty: labels.noResults,
        item: wp.template('instantsearch-hit'), //instantsearch-hit-2
        showMoreText: labels.viewMore,
      },
    });
    main.addWidget(searchHits);
    postsSearch.addWidget(postsSearchHits);
    pagesSearch.addWidget(pagesSearchHits);
    //END TABS

    //SEARCH BOX
    var searchBox = instantsearch.widgets.searchBox({
      container: '#algolia-search-box',
      placeholder: labels.search,
      showReset: false,
      showSubmit: false,
      showLoadingIndicator: false,
    });
    main.addWidget(searchBox);

    //STATS WIDGET
    var statsMain= instantsearch.widgets.stats({
      container: '#algolia-stats-all',
      templates: {
        text: '{{#hasNoResults}}' + labels.zeroResult + '{{/hasNoResults}}{{#hasOneResult}}' + labels.oneResult + '{{/hasOneResult}}\n  {{#hasManyResults}}' + labels.nResult + '{{/hasManyResults}}',
      },
    });

    var statsPages = instantsearch.widgets.stats({
      container: '#algolia-stats-pages',
      templates: {
        text: '{{#hasNoResults}}' + labels.zeroResult + '{{/hasNoResults}}{{#hasOneResult}}' + labels.oneResult + '{{/hasOneResult}}\n  {{#hasManyResults}}' + labels.nResult + '{{/hasManyResults}}',
      },
    });

    var statsPosts = instantsearch.widgets.stats({
      container: '#algolia-stats-posts',
      templates: {
        text: '{{#hasNoResults}}' + labels.zeroResult + '{{/hasNoResults}}{{#hasOneResult}}' + labels.oneResult + '{{/hasOneResult}}\n  {{#hasManyResults}}' + labels.nResult + '{{/hasManyResults}}',
      },
    });

    main.addWidget(statsMain);
    postsSearch.addWidget(statsPosts);
    pagesSearch.addWidget(statsPages);

    postsSearch.start();
    pagesSearch.start();
    main.start();
    
    $('#algolia-search-box input').attr('type', 'search').select();

  },
  finalize: function finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
